// extracted by mini-css-extract-plugin
module.exports = {"carouselLeft":"Pr","carouselRight":"Qr","disabled":"Rr","sliderChevron":"Sr","mobileSlider":"Tr","desktopSlider":"Ur"};